import React from 'react';

interface IFloatLabelProps {
    label: string;
    labelId: string;
    active: boolean;
    children: React.ReactNode;
    htmlFor?: string;
}

const clickThrough = {
    pointerEvents: 'none',
} as React.CSSProperties;

export function FloatLabel({
    active,
    label,
    children,
    labelId,
    htmlFor,
}: IFloatLabelProps) {
    return (
        <div className={active ? 'float-container active' : 'float-container'}>
            {htmlFor ? (
                <label
                    className="float-label"
                    id={labelId}
                    htmlFor={htmlFor}
                    style={clickThrough}
                >
                    {label}
                </label>
            ) : (
                <span className="float-label" id={labelId} style={clickThrough}>
                    {label}
                </span>
            )}

            {children}
        </div>
    );
}
